import { render, staticRenderFns } from "./groupPricingTable.vue?vue&type=template&id=4b92df70&"
import script from "./groupPricingTable.vue?vue&type=script&lang=js&"
export * from "./groupPricingTable.vue?vue&type=script&lang=js&"
import style0 from "./groupPricingTable.vue?vue&type=style&index=0&id=4b92df70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports